<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>This novel is dedicated to my friends Nick and Nora, who were married while it was being written</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?06a0dc4d